import React, { useEffect } from 'react';
import classNames from 'classnames';
import Loader from 'src/components/Loader';
import styles from './assets/expense-create-screen.module.scss';
import RoleLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/ExpenseForm';
import { Paginated } from '../../../../../../services/api-handlers/pagination';
import { IProvider } from '../../../../../../types/provider';
import { QueryParams } from '../../../../../../types/grid';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import { routes } from '../../../../../../navigation';

export interface StateProps {
    inProgress: boolean;
    providers: Paginated<IProvider>;
}

export interface DispatchProps {
    getProviders: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const ExpenseCreateScreen: React.FunctionComponent<Props> = (props) => {
    useEffect(() => {
        props.getProviders({
            page: 1,
            itemsPerPage: 9000,
        });
        // eslint-disable-next-line
    }, []);
    if (props.inProgress) {
        return <Loader />;
    }
    const { providers } = props;

    return (
        <RoleLayout>
            <Breadcrumbs
                items={[
                    { name: 'EXPENSES', path: routes.EXPENSES_LIST },
                    { name: `ADD NEW`, path: '' },
                ]}
            />
            <div className={classNames(styles.wrapForm)}>
                <Form providers={providers.list} initialValues={{}} />
            </div>
        </RoleLayout>
    );
};

export default ExpenseCreateScreen;
